import { render, staticRenderFns } from "./MediationDetail.vue?vue&type=template&id=c1c379f4"
import script from "./MediationDetail.vue?vue&type=script&lang=js"
export * from "./MediationDetail.vue?vue&type=script&lang=js"
import style0 from "./MediationDetail.vue?vue&type=style&index=0&id=c1c379f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports